const voiceRecordingBarStyles = {
  bar: {
    alignItems: "center",
    backgroundColor: "action.hover",
    border: "1px solid",
    borderColor: "divider",
    borderRadius: "2rem",
    margin: { xs: "0.25rem", sm: "0.75rem 1rem" },
    minWidth: 0,
    overflow: "hidden",
    padding: { xs: "0.125rem", sm: "0.5rem" },
  },
  content: {
    alignItems: "center",
    flex: 1,
    minWidth: 0,
  },
  waveform: {
    flex: 1,
    height: "2rem",
    minWidth: 0,
  },
  controlButton: {
    minHeight: "2.75rem",
    minWidth: "2.75rem",
  },
  stopButton: {
    backgroundColor: "action.selected",
    flexShrink: 0,
  },
  sendButton: {
    backgroundColor: "primary.main",
    color: "primary.contrastText",
    flexShrink: 0,
    "&:hover": {
      backgroundColor: "primary.dark",
    },
    "&.Mui-disabled": {
      backgroundColor: "action.disabledBackground",
      color: "action.disabled",
    },
  },
};

export default voiceRecordingBarStyles;
